import {CHANGE_LOCATION} from "../../../constants";

export default (path = ``, action) => {
  const {type, payload} = action;

  switch (type) {
    case CHANGE_LOCATION:
      return payload.location.pathname;
  }

  return path;
};
